import { Button, Form, Modal, notification, Popconfirm, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  createSynopsisAction,
  SynopsisStateInterface,
  deleteSynopsisAction,
  i18n,
  NavigationService,
  StoreStateInterface,
  updateSynopsisAction,
  VerdictStateInterface,
  clearSynopsisListAction,
  getSingleVerdictAction,
  getAllSynopsissAction,
  TagScreenStateInterface,
  getScreenTagsByTypeAction,
} from '../../../../../../../common';
import { ExclamationCircleOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { AdminRoutes } from '../../../../../_router/admin.routes';
import { useDispatch, useSelector } from 'react-redux';
import TextArea from 'antd/lib/input/TextArea';

const { confirm } = Modal;

function VUSSynopsissCrudPageComponent() {

  const dispatch = useDispatch();
  const [form] = Form.useForm<any>();
  const verdict: VerdictStateInterface = useSelector((state: StoreStateInterface) => state.verdict);
  const data: SynopsisStateInterface = useSelector((state: StoreStateInterface) => state.synopsis);
  const tags: TagScreenStateInterface = useSelector((state: StoreStateInterface) => state.tagScreen);

  useEffect(() => {
    dispatch(getScreenTagsByTypeAction('verdict_summary'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verdict.currentVerdict, data.currentSynopsis, data.revision]);

  useEffect(() => {
    form.resetFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const loadData = () => {
    dispatch(getAllSynopsissAction(undefined, `filter[verdict.id]=${verdict.currentVerdict!.id}`, 'sort=id'));
  }

  const onFinishSynopsis = (values: any) => {
    values.synopsiss.forEach((value: any, index: number) => {
      let synopsisTags: Array<{ id: number; type: string }> = [];
      synopsisTags = verdict.currentVerdict?.attributes?.tagIds?.map((id) => ({
        id: id,
        type: 'tag',
      })) as Array<{ id: number; type: string }>;
      let synopsisData: any = {
        data: {
          type: 'verdict_summary',
          id: data.synopsiss?.data[index]?.id,
          attributes: {
            titleContent: value?.titleContent,
            textContent: value?.textContent,
          },
          relationships: {
            verdict: {
              data: {
                id: verdict.currentVerdict?.id,
                type: 'verdict',
              },
            },
            tags: {
              data: synopsisTags,
            },
          },
        },
      };

      !synopsisData?.data?.id
        ? dispatch(createSynopsisAction(synopsisData, values?.synopsiss.length == index + 1))
        : dispatch(updateSynopsisAction(synopsisData, values?.synopsiss?.length == index + 1));
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
      NavigationService.navigate(AdminRoutes.VUS_DECLARATIONS.fullPath);
    }, 2000);
  };

  const onFinishSynopsisFailed = (errorInfo: any) => {
    notification['error']({ message: i18n.translate('genericFormMsg.pleaseCheck'), duration: 2 });
    console.log('Failed:', errorInfo);
  };

  const loadInitialValues = () => {
    let values: any = data.synopsiss?.data?.map((synopsis) => ({
      titleContent: synopsis?.attributes?.titleContent,
      textContent: synopsis?.attributes?.textContent,
    }));

    return values;
  };

  const loadDefaultValues = () => {
    let values: any = [];

    return values;
  };

  const showConfirm = (key: number) => {
    confirm({
      title: i18n.t('synopsiss.confirmDelete'),
      icon: <ExclamationCircleOutlined />,
      content: i18n.t('common.cantUndo'),
      okText: i18n.t('genericButtons.yes'),
      cancelText: i18n.t('genericButtons.cancel'),
      onOk() {
        dispatch(deleteSynopsisAction(data.synopsiss?.data[key]?.id as number));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  };

  const clearSynopsisList = () => {
    dispatch(clearSynopsisListAction());
  };

  const addSynopsis = () => {
    let synopsisTags: Array<{ id: number; type: string }> = [];
    synopsisTags = verdict.currentVerdict?.attributes?.tagIds?.map((id) => ({
      id: id,
      type: 'tag',
    })) as Array<{ id: number; type: string }>;
    let synopsisData: any = {
      data: {
        type: 'verdict_summary',
        attributes: {
          titleContent: '',
          textContent: '',
        },
        relationships: {
          verdict: {
            data: {
              id: (verdict.currentVerdict?.id as number),
              type: 'verdict',
            },
          },
          tags: {
            data: synopsisTags,
          },
        },
      },
    };
    dispatch(createSynopsisAction(synopsisData));
  };

  const removeRecord = () => {
    dispatch(deleteSynopsisAction(data.synopsiss?.data[0]?.id as number));
  }

  const genExtra = (key: number) => <DeleteOutlined onClick={() => showConfirm(key)} className="button" />;

  return (
    <div className="vusSynopsissCrud w100-h100">
      {(
        <Form
          form={form}
          layout="vertical"
          name="synopsis"
          size="large"
          scrollToFirstError
          onFinish={onFinishSynopsis}
          onFinishFailed={onFinishSynopsisFailed}
          autoComplete="off"
          requiredMark={false}
        >
          <div className="vusSynopsissCrud__form">
            <Form.List
              initialValue={loadInitialValues()}
              name="synopsiss"
            >
              {(fields) => (
                <>
                  {fields.map(({ key, name }) => (
                    <Space
                      key={key}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                        marginBottom: 8,
                      }}
                      align="baseline"
                    >
                      <Form.Item
                        label={
                          <span className="text-bold">{i18n.translate(`synopsiss.form.fields.titleContent`)}</span>
                        }
                        name={[name, 'titleContent']}
                        rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <TextArea autoSize={{ minRows: 2 }} />
                      </Form.Item>
                      <Form.Item
                        label={<span className="text-bold">{i18n.translate(`synopsiss.form.fields.textContent`)}</span>}
                        name={[name, 'textContent']}
                        rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <TextArea autoSize={{ minRows: 8 }} />
                      </Form.Item>
                    </Space>
                  ))}
                </>
              )}
            </Form.List>
            {data.synopsiss?.data?.length === 0 ? (
              <Button style={{ marginTop: 16 }} type="link" onClick={() => addSynopsis()} block icon={<PlusOutlined />}>
                {i18n.translate(`synopsiss.crudTitleAdd`)}
              </Button>
            ) : null}
          </div>
          <div className="vusSynopsissCrud__bottomButtons">
            <div>
              {data.synopsiss?.data?.length !== 0 ? (
                <Popconfirm
                  title={i18n.t('common.recordRemoval')}
                  onConfirm={() => removeRecord()}
                  onCancel={() => {}}
                  okText={i18n.t('genericButtons.yes')}
                  cancelText={i18n.t('genericButtons.no')}
                  placement="left"
                >
                <Button
                      danger
                      className="button"
                      size="large"
                      style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193, marginRight: 16 }}
                    >
                      {i18n.translate('genericButtons.delete')}
                    </Button>
                </Popconfirm>
              ) : null}
            </div>
            <div>
              <Link to={AdminRoutes.VUS_DECLARATIONS.fullPath} key={AdminRoutes.VUS_DECLARATIONS.path}>
                <Button
                  onClick={clearSynopsisList}
                  className="button"
                  size="large"
                  style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193, marginRight: 16 }}
                >
                  {i18n.translate('genericButtons.cancel')}
                </Button>
              </Link>
              <Button
                className="button"
                htmlType="submit"
                type="primary"
                size="large"
                style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193 }}
              >
                {i18n.translate('genericButtons.save')}
              </Button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
}

export default VUSSynopsissCrudPageComponent;
